<template>
  <b-table :data="assignments" bordered striped narrowed detailed detail-key="id" :has-detailed-visible="row => true"
    :opened-detailed="openedRows" checkable :checked-rows.sync="localCheckedRows" @details-open="onDetailsOpen"
    @details-close="onDetailsClose" @check="onCheck" class="text-xs border-blue-lighter bg-grey-lighter">
    <b-table-column field="type" :label="$t('type')">
      <template v-slot="assignment">
        {{ assignment.row.type }}
      </template>
    </b-table-column>
    <b-table-column field="description" :label="$t('name')">
      <template v-slot="assignment">
        {{ assignment.row.description }}
      </template>
    </b-table-column>
    <b-table-column field="unit_name" :label="$t('unit')">
      <template v-slot="assignment">
        {{ assignment.row.unit_name }}
      </template>
    </b-table-column>
    <b-table-column field="total" :label="$t('total_quantity')">
      <template v-slot="assignment">
        {{ assignment.row.total }}
      </template>
    </b-table-column>
    <b-table-column field="executed_quantity" :label="$t('executed_quantity')">
      <template v-slot="assignment">
        {{ assignment.row.executed_quantity }}
      </template>
    </b-table-column>

    <b-table-column field="weight" :label="$t('weight')">
      <template v-slot="assignment">
        {{ assignment.row.weight }}
      </template>
    </b-table-column>
    <template slot="detail" slot-scope="assignment">
      <div v-if="assignment.row.loadingChild">
        <b-loading :is-full-page="false" />
      </div>
      <div v-else-if="assignment.row.child && assignment.row.child.length">
        <assignment-table :assignments="assignment.row.child" :opened-rows.sync="openedRows"
          :checked-rows.sync="checkedRows" />
      </div>
      <div v-else>
        <span>{{ $t('empty_assignments_table_msg') }}</span>
      </div>
    </template>
  </b-table>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AssignmentTable',
  props: {
    assignments: { type: Array, required: true },
    openedRows: { type: Array, default: () => [] },
    checkedRows: { type: Array, default: () => [] },
  },
  data() {
    return {
      localCheckedRows: [...this.checkedRows]
    }
  },
  watch: {
    checkedRows(newVal) {
      this.localCheckedRows = [...newVal];
    }
  },
  methods: {
    async onDetailsOpen(row) {
      if (!this.openedRows.includes(row.id)) {
        this.$emit('update:openedRows', [...this.openedRows, row.id]);
      }
      if (!row.child) {
        this.$set(row, 'loadingChild', true);
        try {
          const response = await axios.get(`/api/v2/assignment/${row.id}/child`);
          this.$set(row, 'child', response.data.data);
        } catch (e) {
          this.$set(row, 'child', []);
        }
        this.$set(row, 'loadingChild', false);
      }
    },
    onDetailsClose(row) {
      this.$emit('update:openedRows', this.openedRows.filter(id => id !== row.id));
    },
    onCheck(checkedRows) {
      this.localCheckedRows = checkedRows;
      this.$emit('update:checkedRows', checkedRows);
    }
  }
}
</script>